<template>
  <TemplateModal ref="modal" center width="910" empty>
    <template v-slot:activator>
      <button
        class="buttonActivator"
        :class="{ 'buttonActivator--disabled': recipients.length === 0 }"
        :disabled="recipients.length === 0"
        @click="onOpenModal"
      >
        {{
          projectsStatus
            ? localStorage.translations.pages['common'].pagination['vse']
            : recipients.length === 0
            ? localStorage.translations.pages['common'].text['everyone']
            : recipients.length
        }}
      </button>
    </template>
    <div class="list">
      <div class="chip f12" v-for="(recipient, key) in recipients" :key="'recipient_' + key">
        {{ projectsStatus ? recipient.name : recipient.first_name + ' ' + recipient.last_name }}
      </div>
    </div>
  </TemplateModal>
</template>

<script>
// import UsersListItem from 'components/setting/users/UsersListItem'
import TemplateModal from 'components/templates/TemplateModal'
import { mapGetters, mapActions, mapMutations } from 'vuex'

export default {
  name: 'SettingsPushNotificationsRecipientsModal',
  props: {
    recipients: Array,
    projectsStatus: String,
  },
  components: {
    TemplateModal,
  },
  data: () => ({
    dialog: false,
  }),
  methods: {
    onOpenModal() {
      this.$refs.modal.openModal()
    },
  },
}
</script>

<style lang="scss" scoped>
.buttonActivator {
  padding: 10px 0;
  text-align: start;
  padding: 8px;
  transition: 0.3s;
  border-radius: 4px;
  &:not(.buttonActivator--disabled):hover {
    background: #277faf;
    color: #ffffff;
  }
}
.list {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  width: 100%;
}
.chip {
  border: 1px solid #bedbeb;
  width: max-content;
  padding: 8px;
  border-radius: 4px;
  color: #2c2c2c;
  height: max-content;
  // cursor: pointer;
  overflow: hidden;
  width: 100%;
  display: grid;
  gap: 10px;
  white-space: nowrap;
  max-width: max-content;
  border: none;
  background-color: #277faf;
  color: #ffffff;
  span {
    display: inline-block;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
  }
}
</style>
